import { pageMetadataFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'
import menuItemCategory from '../menuItemCategory'
import { videoAsset } from '@/data/sanity/fragments'
import link from '../link'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  itemsByCategory[]{
    categoryReference->{${menuItemCategory.fields}},
    items[]-> {
      ${pageMetadataFields}
    }
  },
  ${videoAsset.fragment('allergenGuidePdf')},
  ${link.fragment('allergenGuideLink')},
  allergenText,
`

export const fragment = (name = 'menuListing') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
